import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { getImageUrlThumb } from '@helpers';

@Component({
  selector: 'app-modal-markers-in-cluster',
  templateUrl: './modal-markers-in-cluster.component.html',
  styleUrls: ['./modal-markers-in-cluster.component.scss'],
  standalone: false,
})
export class ModalMarkersInClusterComponent implements OnInit {
  @Input() markers: any;

  constructor(private router: Router) {}

  ngOnInit(): void {
    this.markers.forEach((marker) => {
      marker.fullAddress = this.generateFullAddress(marker).trim();
    });
  }

  seeDetails(event, marker) {
    this.router.navigate([`/property/${marker.id}/${marker.slug || 'addr'}`]);
  }

  generateFullAddress(marker) {
    return `${marker.address?.street || ''} ${marker.address?.houseNumber || ''}`;
  }

  protected readonly getImageUrlThumb = getImageUrlThumb;
}
